import {
    apiRequest,
    kgbUploadSK,
    kgbDetail,
} from "../../../../../services/adapters/kepegawaian/kgbService"

class UploadSKRepository {

    fetchUploadSk = async (query) => {
        return await apiRequest("post", kgbUploadSK, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", kgbDetail, {
            params: query
        }, true)
    }
}

export default UploadSKRepository